import { render, staticRenderFns } from "./togetherAiUpgradeNew.vue?vue&type=template&id=752d9c2e&scoped=true"
import script from "./togetherAiUpgradeNew.vue?vue&type=script&lang=js"
export * from "./togetherAiUpgradeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752d9c2e",
  null
  
)

export default component.exports